/**
 * Detects if the user is on an iOS device
 */
const isIOS = (): boolean => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * Detects if the user is on an Android device
 */
const isAndroid = (): boolean => {
    return /Android/i.test(navigator.userAgent);
};

export interface DownloadResult {
    success: boolean;
    platform: 'ios' | 'android' | 'desktop';
    message?: string;
}

/**
 * Triggers a download of an iCal file with platform-specific handling
 * @param icsContent - The iCal file content as a string
 * @param filename - The filename for the downloaded file (default: 'appointment.ics')
 * @returns DownloadResult object with success status and platform information
 */
export const downloadCalendarEvent = (
    icsContent: string,
    filename: string = 'appointment.ics',
): DownloadResult => {
    try {
        // Create a blob with the iCal content
        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });

        // Determine platform
        const platform = isIOS() ? 'ios' : isAndroid() ? 'android' : 'desktop';

        if (isIOS()) {
            // iOS specific handling
            // iOS Safari handles .ics files better with specific MIME type and direct link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            link.setAttribute('target', '_blank');

            // Append to body, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up with a slight delay for iOS
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
            }, 100);

            return {
                success: true,
                platform: 'ios',
                message: 'Tapi skedarin dhe zgjidh "Shto në Kalendar"',
            };
        } else {
            // Standard download for Android and Desktop
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;

            // Append to body, click, and remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up the URL
            window.URL.revokeObjectURL(url);

            return {
                success: true,
                platform,
                message:
                    platform === 'android' ? 'Skedari u shkarkua' : 'Rezervimi u shtua në kalendar',
            };
        }
    } catch (error) {
        console.error('Error downloading calendar event:', error);
        return {
            success: false,
            platform: isIOS() ? 'ios' : isAndroid() ? 'android' : 'desktop',
            message: 'Gabim gjatë shkarkimit të skedarit',
        };
    }
};
